import { useTranslation } from 'react-i18next';
import styles from './ClearFiltersButton.module.css';

interface IClearFiltersButtonProps {
  /** Renders nothing when 0. */
  count: number;
  onClear: () => void;
}

// Renders as <span role="button"> rather than <button> because the issues
// sidebar nests it inside the section-toggle button, and HTML disallows
// nested buttons.
export function ClearFiltersButton({ count, onClear }: IClearFiltersButtonProps) {
  const { t } = useTranslation();
  if (count === 0) return null;
  return (
    <span
      role="button"
      tabIndex={0}
      className={styles.button}
      onClick={(e) => {
        e.stopPropagation();
        onClear();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          onClear();
        }
      }}
    >
      {t('common.clearN', { count })}
    </span>
  );
}
